import { Component } from '@theme/component';

/**
 * Minimal horizontal carousel for cart drawer upsell products.
 * Follows the same Component/refs/on:click pattern used everywhere
 * else in this theme — no external libraries, no extra dependencies.
 */
class CartUpsellCarousel extends Component {
  requiredRefs = ['track'];

  connectedCallback() {
    super.connectedCallback();
    this.index = 0;
    this.#render();
  }

  next() {
    const count = this.refs.track.children.length;
    this.index = Math.min(this.index + 1, count - 1);
    this.#render();
  }

  previous() {
    this.index = Math.max(this.index - 1, 0);
    this.#render();
  }

  /** @param {{ index: number }} data */
  goTo(data) {
    this.index = Number(data.index) || 0;
    this.#render();
  }

  #render() {
    const track = this.refs.track;
    const count = track.children.length;

    track.style.transform = `translateX(-${this.index * 100}%)`;

    if (this.refs.previous) this.refs.previous.disabled = this.index === 0;
    if (this.refs.next) this.refs.next.disabled = this.index >= count - 1;

    const dots = this.refs.dot;
    if (Array.isArray(dots)) {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }
  }
}

if (!customElements.get('cart-upsell-carousel')) {
  customElements.define('cart-upsell-carousel', CartUpsellCarousel);
}
